import React from 'react';
import NextLink from 'next/link';

import {buildUrl, useAppRouter, withSectionQuery} from '../../../../lib/routes';

type Props = {
	args: string[];
};

// {@bookSection PaBTSO, PaBTSO-04, ruiny-tandertri, «Руины Тандертри»}
export const BookSectionPlugin: React.FC<Props> = ({args}) => {
	const router = useAppRouter();
	const [bookId, chapterId, sectionId, ...rest] = args;
	const title = rest.join(', ') || sectionId;

	const params = withSectionQuery(router?.asPath, 'bookChapter', {bookId, chapterId});

	return (
		<NextLink href={`${buildUrl('bookChapter', params)}#${sectionId}`} title={title}>
			{title}
		</NextLink>
	);
};
